import React from "react";
import TrashIcon from "../../elements/icons/TrashIcon";
import EmptyState from "../../elements/EmptyState";
import PlusIcon from "../../elements/icons/PlusIcon";
import ModalDialog from "../../layouts/ModalDialog";
import NewElectiveSubject from "./NewElectiveSubject";
import { ERROR, SET_SUCCESS } from "../../../store/types";
import { authHeader, baseUrl } from "../../../utils";
import axios from "axios";
import { useDispatch } from "react-redux";

const ElectiveSubjects = ({ subjects, reload }) => {
  const [creatingElective, setCreatingElective] = React.useState(false);
  const dispatch = useDispatch();

  const handleDeleteElective = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this subject as an elective? This action cannot be undone.",
      )
    ) {
      try {
        const headers = authHeader();
        await axios.delete(
          `${baseUrl}/academic-settings/elective-subject/${id}`,
          { headers },
        );
        dispatch({
          type: SET_SUCCESS,
          payload: "Elective subject removed successfully",
        });
        reload();
      } catch (error) {
        console.log("error removing elective subject: ", error);
        dispatch({
          type: ERROR,
          error,
        });
      }
    }
  };
  return (
    <>
      {subjects?.length > 0 ? (
        <div className="w-full">
          {subjects.map((subject, index) => (
            <div
              key={index}
              className="w-full rounded-lg bg-white p-5 mb-4 border border-gray-200 relative"
            >
              <div className="absolute top-2 right-2 flex flex-row-reverse items-center gap-x-2">
                <button
                  onClick={() => {
                    handleDeleteElective(subject._id);
                  }}
                  className="p-1.5 bg-gray-100 rounded bg-transparent hover:bg-red-100 transition duration-200 text-xs flex items-center justify-center gap-x-1 text-gray-500 hover:text-vcm-purple"
                >
                  <TrashIcon className={`w-4 h-4`} />
                  Remove Elective
                </button>
              </div>

              <h3 className="font-semibold text-sm text-gray-800">
                {subject.subject.name}
              </h3>
              <p className="text-sm text-gray-800">
                {subject.subject.description}
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Classes: {subject.classes.map((cl) => cl.name).join(", ")}
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Prerequisite for{" "}
                <span className="text-gray-800 font-semibold capitalize">
                  {subject?.studentStudyType?.toLowerCase() || "all"} students
                </span>{" "}
                of the above classes
              </p>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          emptyStateTitle={`No elective subjects.`}
          emptyStateText={`No elective subjects have been set yet. Click the button below to add a new elective subject.`}
        />
      )}
      <button
        onClick={() => {
          setCreatingElective(true);
        }}
        className="w-max mx-auto p-3 text-xs border border-dashed border-gray-500 bg-white transition duration-200 flex items-center justify-center gap-x-1 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold"
      >
        <PlusIcon className={`w-4 h-4 inline-block`} />
        Add New Elective Subject
      </button>

      <ModalDialog
        shown={creatingElective}
        closeFunction={() => {
          setCreatingElective(false);
        }}
        actionFunction={() => {}}
        actionFunctionLabel={``}
        dialogTitle={`Create a New Elective Subject`}
        maxWidthClass="max-w-xl"
        hideActions={true}
      >
        <NewElectiveSubject
          close={() => setCreatingElective(false)}
          reload={reload}
        />
      </ModalDialog>
    </>
  );
};

export default ElectiveSubjects;
